import { PREDEFINED_TREE_NODES } from '~/src/tabs/GoogleDrive/data/consts';
import getGDrive from '~/src/tabs/GoogleDrive/service';

export const getFiles = async (actionType, options, dispatch) => {
  const { parentId: id } = options;
  const getDrives = id === PREDEFINED_TREE_NODES.SHARED_DRIVE;
  options.forceTreeUpdate = getDrives;
  dispatch({ type: actionType.PENDING, payload: { id } });

  try {
    const result = getDrives ? await getGDrive().getDrives(options) : await getGDrive().getFiles(options);

    dispatch({ type: actionType.SUCCESS, payload: { result, options } });
  } catch (error) {
    dispatch({ type: actionType.FAILURE, payload: { id, error } });
  }
};
